import { AppLayoutBreakpoint, FeatureBreakpoint, LegacyPageLayoutBreakpoint } from '../../util/responsiveness';

import { PageLayoutWidth } from './PageLayout.types';

export const mapPixelWidthToPageLayoutWidth = (width: number) => {
  if (width <= AppLayoutBreakpoint.Width812) {
    return PageLayoutWidth.Small;
  }

  if (width > FeatureBreakpoint.Width700 && width <= LegacyPageLayoutBreakpoint.Width1044) {
    return PageLayoutWidth.Medium;
  }

  if (width > LegacyPageLayoutBreakpoint.Width1044 && width <= LegacyPageLayoutBreakpoint.Width1304) {
    return PageLayoutWidth.Large;
  }

  return PageLayoutWidth.XLarge;
};
